<template>
  <div class="opening-times">
    <h1 style="margin-bottom: 15px">Sprechzeiten</h1>
    <v-card
      v-for="(praxis, i) in praxisData"
      :key="i"
      class="opening-card"
      style="display: inline-block; margin: 15px; padding: 20px;"
    >
      <h2>{{ praxis.name }}</h2>
      <h4>{{ praxis.address }}</h4>
      <h5>{{ praxis.phone }}</h5>
      <div style="margin-top: 20px">
        <div
          v-for="times, day in praxis.opening"
          :key="day"
          style="line-height: 2rem"
        >
          <span style="text-transform: capitalize;">
            {{ day }}.: 
          </span>
          <span
            v-for="period, j in times"
            :key="j"
          >
            {{ period.start }} - {{ period.end }}<span v-if="period.info"> ({{ period.info }})</span><span v-if="j < times.length - 1">, </span>
          </span>
        </div>
      </div>
    </v-card>
    <br>
    <v-card class="opening-card d-inline-block" style="text-align: left;">
      <section style="font-family: system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif; line-height: 1.6; color: #111; background: #fff; padding: 24px; border: 1px solid #eee; border-radius: 12px; max-width: 820px; margin: 0 auto;">
        <header style="margin-bottom: 16px;">
          <h1 style="margin: 0 0 8px; font-size: 28px;">Arzthelfer/-in (MFA)</h1>
          <div style="display: flex; flex-wrap: wrap; gap: 8px; font-size: 14px;">
            <span style="background:#f5f5f5; border:1px solid #eaeaea; padding:4px 8px; border-radius:999px;">Berufserfahrung: Mit Berufserfahrung</span>
            <span style="background:#f5f5f5; border:1px solid #eaeaea; padding:4px 8px; border-radius:999px;">Arbeitszeit: Voll/Teilzeit</span>
          </div>
        </header>

        <section style="margin: 20px 0;">
          <h2 style="font-size: 18px; margin: 0 0 8px;">Beschreibung</h2>
          <p style="margin: 0;">
            Wir sind eine moderne Hausarztpraxis mit -durschschnittlich- 2400 Fälle pro Quartal in Nordenham, suchen ab sofort eine MFA in Vollzeit.
          </p>
        </section>

        <section style="margin: 20px 0;">
          <h2 style="font-size: 18px; margin: 0 0 8px;">Ihre Aufgaben</h2>
          <ul style="margin: 0; padding-left: 18px;">
            <li>Patientenannahme</li>
            <li>Terminvergabe</li>
            <li>Blutentnahme</li>
            <li>Behandlungsassistenz</li>
            <li>Büro</li>
          </ul>
        </section>

        <section style="margin: 20px 0;">
          <h2 style="font-size: 18px; margin: 0 0 8px;">Wir bieten</h2>
          <p style="margin: 0 0 8px;">Bezahlung nach Tarif plus Leistungsorientiertes Bonussystem, bis +34%</p>
          <ul style="margin: 0; padding-left: 18px;">
            <li>Tankgutschein 50 Euro</li>
            <li>einen unbefristeten Arbeitsvertrag</li>
            <li>Förderung bei beruflichen Weiterbildung/Studium (zB. Physician Assistent, später auch Medizinstudium mit Stipendium)</li>
          </ul>
        </section>

        <section style="margin: 20px 0;">
          <h2 style="font-size: 18px; margin: 0 0 8px;">Interesse?</h2>
          <p style="margin: 0;">
            Wenn Sie Lust haben in einem kollegialen und motivierten Team zu arbeiten, empathisch und freundlich im Umgang mit Patienten sind, dann melden Sie bei mir per Mail oder persönlich/ per Post!
          </p>
          Adresse:
          Praxis
          Dr. Szabo
          Bahnhofstr. 51.a
          26954 Nordenham
        </section>
      </section>

    </v-card>
  </div>
</template>

<script>
export default {
  name: 'OpeningTimes',

  props: {
    praxisData: {
      type: Object,
      required: true,
    }
  }
}
</script>

<style scoped>
.opening-times {
  background-color: #dbd3d8;
  width: 100%;
  padding: 30px;
  text-align: center;
}

h5 {
  display: none;
}

@media screen and (max-width: 1100px) {
  h5 {
    display: block;
  }
}

.opening-card {
  width: 600px;
}

@media screen and (max-width: 1260px) {
  .opening-card {
    width: 300px;
  }
}
</style>